import { _, $, Marionette } from "../../vendor";
import InboomaBaseView from "./InboomaBaseView";
import { appCollectionEmptyTpl } from "./AppAnnouncements";

const InboomaBaseCollectionView = Marionette.CollectionView.extend({
  collectionEmptyTpl: appCollectionEmptyTpl,
  t: InboomaBaseView.prototype.t,

  /**
   * Called after changing collection models
   * Toggles visibility of "No entities found - remove filter (if any)" container
   */
  _checkForEmptyCollection() {
    const that = this;

    if (!this.collection.models.length) {
      // test for inb-loader--small several times if collection is empty and loader still visible
      if (this.$("#inb-app-collection-empty").length < 1) {
        if (!$(".inb-loader--small").hasClass("hide")) {
          setTimeout(() => {
            that._checkForEmptyCollection();
          }, 300);
        } else {
          // collection is empty and loader not visible anymore
          this.$el.append(this.collectionEmptyTpl);
        }
      }
    } else {
      // collection is not empty
      this.$("#inb-app-collection-empty").remove();

      /*const collection = (typeof this.collection._superset !== 'undefined'
                              ? this.collection._superset
                              : this.collection);*/

      // check pagination
      /*if (typeof collection._pagination !== 'undefined' && typeof collection._skipPagination === 'undefined' && collection._pagination.has_next_page) {
            // are there really more entrys to load?
            // it is possible that a collection has more entrys than the page limit but not after using a local filter (see: order list)
            if (typeof collection.proxy !== 'undefined' && typeof collection.proxy._filtered !== 'undefined') {

              if ( (collection.length - collection.proxy._filtered.length) > (2*collection._pagination.limit) ) {
                // difference between api data and filtered data is bigger than a whole page -> there is nothing to load anymore
                // this is a work around for orders collection to prevent loading more and more orders without matching reservation filter
                //loadMoreBtn.hide();    // remove this for now because sometime the difference is huge but there are still orders that match the filter
                loadMoreBtn.show();
              } else {
                loadMoreBtn.show();
              }
            } else {
              loadMoreBtn.show();
            }
          }*/
    }
  },

  onDomRefresh() {
    this._checkForEmptyCollection();
  },

  initialize() {
    const that = this;

    Marionette.CollectionView.prototype.initialize.apply(this);

    this.collection.on("all", () => {
      that._checkForEmptyCollection();
    });
  },
});

// Same as in InboomaBaseView.js
InboomaBaseCollectionView.setRenderer(function (template, data) {
  data.t = this.t;

  if (typeof template === "function") {
    return template(data);
  }

  return _.template(template)(data);
});

export default InboomaBaseCollectionView;
